import { dispatcher } from "@quest/base-core";
import { GameIntroController } from "@quest/murka-games-behavior-panther/dist"
import { eventDispatchers } from "../Constants/EventDispatchers";
export class GameIntroControllerGame extends GameIntroController {
    /**
     * to enable post loading screen view
     */
    protected bindContinueButton(): void {
        super.bindContinueButton();
        dispatcher.fireEvent(eventDispatchers.SHOW_POSTLOADING_VIEW);
    }
}
